import React, { FC, useContext } from 'react';
import {
  ActionBar,
  PrimaryButton,
  ResourceAction,
  useScopedSelector,
} from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import cookie from 'cookie';
import { useNavigate } from 'react-router-dom';
import useCookie from 'react-use-cookie';
import { useDispatch } from 'react-redux';
import ChangePasswordContext from '../../../../utils/ChangePasswordContext';
import { setIsModalOpened } from '../../ChangePasswordPage.actions';
import { onSuccessPassword } from './onSuccessPassword';
import Configuration from '../../../../utils/Configuration';
import useHandleChangePassword from './useHandleChangePassword';
import useHandleOnFailure from './useHandleOnFailure';

export interface ConfirmButtonActionBarProps { }

const ConfirmButtonActionBar: FC<ConfirmButtonActionBarProps> = () => {
  const config = Configuration.Current();
  const dispatch = useDispatch();
  const { t } = useTranslation('ChangePasswordPage');
  const password: string = useScopedSelector('ChangePasswordFormValues.password');
  const cookies = cookie.parse(document.cookie);
  const { oktaStateToken, awAccountManagementVersion, username } = cookies;
  if (oktaStateToken === undefined) {
    dispatch(setIsModalOpened(true));
  }
  let awAccountManagementVersionLocal = 'v1';
  if (awAccountManagementVersion === 'v2') {
    awAccountManagementVersionLocal = 'v2';
  }
  const navigate = useNavigate();
  const [, setUserNameCookie] = useCookie('ln');
  const isValid: boolean = useScopedSelector('ChangePasswordForm.isValid');
  const handleChangePassword = useHandleChangePassword();
  const handleOnFailure = useHandleOnFailure();
  const { rules, setRules } = useContext(ChangePasswordContext);

  return (
    <ActionBar flexButtons>
      <ResourceAction
        name="ActionChangePassword"
        url={`${config.awAccountManagement}/${awAccountManagementVersionLocal}/password`}
        config={{ validateStatus: (status) => status <= 400 }}
        method="POST"
        cancelButton={t('PasswordCancel')}
        retryButton={t('PasswordRetry')}
        tryAgainMessage={t('PasswordRetry')}
        data={{
          NewPassword: password,
          StateToken: oktaStateToken,
          userType: config.userType,
          businessEntityCode: config.businessEntityCode,
          username,
        }}
        onSuccess={(response) => {
          handleChangePassword(response);
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          onSuccessPassword(response, dispatch, navigate, setUserNameCookie, setRules, rules);
        }}
        onFailure={(error) => {
          handleOnFailure(JSON.stringify((error as unknown as { message: string }).message));
        }}
      >
        {({ pending, requestResource }) => (
          <PrimaryButton
            type="submit"
            busy={pending}
            data-testid="Save"
            onClick={() => {
              if (isValid) requestResource();
            }}
          >
            {t('PasswordSubmit')}
          </PrimaryButton>
        )}
      </ResourceAction>
    </ActionBar>
  );
};
export default ConfirmButtonActionBar;
